import { generatePath } from 'react-router'

import { routes } from '~/queries/routes'
import { CategoriesIcon } from '~/components/icons'
import { trackEvent } from '~/utils/tracking'
import { Link } from '@remix-run/react'
import { Entry } from 'contentful'
import { TypeCategorySortingSkeleton } from '~/types/contentful'

type CategoriesProps = {
  categoriesInfo: Entry<TypeCategorySortingSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const Categories = ({ categoriesInfo }: CategoriesProps) => {
  const categories = categoriesInfo?.fields?.categories || categoriesInfo

  return (
    <div className="text-neutral-100 left-0 pb-25 sticky w-full top-[calc(55px_+_var(--header-height))]">
      <ul
        className="webkit-scrollbar-none list-none p-0 m-0 max-h-[80vh] overflow-y-auto"
        style={{ scrollbarWidth: 'none' }}
      >
        <li className="mb-8">
          <Link
            className="text-s inline-flex py-3 px-5 items-center rounded-[30px] bg-white transition-[background-color] ease hover:duration-150 duration-300"
            to={routes.careerAdvice}
          >
            <CategoriesIcon className="mr-2" /> All Posts
          </Link>
        </li>
        {categories.map((category) => (
          <li className="[&:not(:last-child)]:mb-2" key={category?.fields.slug}>
            <Link
              className="text-s inline-flex py-3 px-5 items-center rounded-[30px] bg-white transition-[background-color] ease hover:duration-150 duration-300"
              to={generatePath(routes.resourcesCategory, { category: category?.fields.slug })}
              onClick={() =>
                trackEvent('click_category', {
                  category: category?.fields.name as string,
                })
              }
            >
              {category?.fields.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
